import React, { useEffect } from "react";
import Home from "./pages/home";
import Header from "./components/header";
import Serve from "./pages/serve";
import FAQ from "./pages/faq";
import FAQ2 from "./pages/faq2";
import FAQ3 from "./pages/faq3";
import FAQ4 from "./pages/faq4";
import Footer from "./components/footer";
import Login from "./pages/login";
import Resources from "./pages/resources";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";

function App() {
  return (
    <div className="App" style={{ minHeight: "100vh" }}>
      <Router>
        <Header />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/login">
            <Login />
          </Route>
          <Route exact path="/faq">
            <FAQ />
          </Route>
          <Route exact path="/faq2">
            <FAQ2 />
          </Route>
          <Route exact path="/faq3">
            <FAQ3 />
          </Route>
          <Route exact path="/faq4">
            <FAQ4 />
          </Route>
          <Route exact path="/serve">
            <Serve />
          </Route>
          <Route exact path="/resources">
            <Resources />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
